import React, { PureComponent } from 'react';
import { Table, Form, Modal, Input, InputNumber, Checkbox, Button } from 'antd';
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'immutability-helper';

import "./editTable.scss"

const EditableContext = React.createContext();

let dragingIndex = -1;
class BodyRow extends React.Component {
    render() {
        const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
        const style = { ...restProps.style, cursor: 'move' };

        let { className } = restProps;
        if (isOver) {
            if (restProps.index > dragingIndex) {
                className += ' drop-over-downward';
            }
            if (restProps.index < dragingIndex) {
                className += ' drop-over-upward';
            }
        }

        return connectDragSource(
            connectDropTarget(<tr {...restProps} className={className} style={style} />),
        );
    }
}

const rowSource = {
    beginDrag(props) {
        dragingIndex = props.index;
        return {
            index: props.index,
        };
    },
};
const rowTarget = {
    drop(props, monitor) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        if (dragIndex === hoverIndex) {
            return;
        }

        props.moveRow(dragIndex, hoverIndex);
        monitor.getItem().index = hoverIndex;
    },
};
const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}))(
    DragSource('row', rowSource, connect => ({
        connectDragSource: connect.dragSource(),
    }))(BodyRow),
);

class EditableCell extends PureComponent {

    getInput = () => {
        if (this.props.inputType === 'number') {
            return <InputNumber min={0} formatter={value => `${value}`.replace(/[^\d]/g,'')} />;
        } else if (this.props.inputType === 'select') {
            return <Checkbox></Checkbox>
        }
        return <Input />;
    }

    renderCell = ({ getFieldDecorator }) => {
        const { editing, dataIndex, title, inputType, record, index, children, ...restProps } = this.props;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            initialValue: record[dataIndex],
                            valuePropName: dataIndex === 'isShow' ? 'checked' : 'value',
                        })(this.getInput())}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

    render() {
        return <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>;
    }
}

class EditTable extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            editingKey: '',// record的key
            datalist: [],
            columns: [
                {
                    title: '列名',
                    dataIndex: 'title',
                    key: 'title',
                    editable: false,
                    width: 120
                },
                {
                    title: '位置',
                    dataIndex: 'pos',
                    key: 'pos',
                    align: 'center',
                    // editable: true,
                    width: 120,
                    render: (text, record, index) => {  //生成序号
                        return (
                            <span>{index + 1}</span>
                        )
                    },
                },
                {
                    title: '宽度',
                    dataIndex: 'width',
                    key: 'width',
                    align: 'center',
                    editable: true,
                    width: 120
                },
                {
                    title: '显示',
                    dataIndex: 'isShow',
                    key: 'isShow',
                    align: 'center',
                    editable: true,
                    width: 100,
                    render: (record) => record === true ? '显示' : '不显示'
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    width: 120,
                    render: (text, record) => {
                        const { editingKey } = this.state;
                        const editable = this.isEditing(record);
                        return editable ? (
                            <span style={{display:'flex'}}>
                                <EditableContext.Consumer>
                                    {form => (
                                        <Button  onClick={() => this.save(form, record.key)} style={{ marginRight: 8 }} className="buttonIcon">
                                            保存
                                        </Button>
                                    )}
                                </EditableContext.Consumer>
                                <Button onClick={this.cancel} className="buttonIcon">取消</Button>
                            </span>
                        ) : (
                            <Button disabled={editingKey !== ''} onClick={() => this.edit(record.key)} className="buttonIcon">
                                编辑
                            </Button>
                        );
                    },
                },
            ]
        }
    }

    componentDidMount() {
        this.setState({
            datalist: this.props.setTabData,
        })
    }

    // 取消时清空编辑框
    cancel = () => {
        this.setState({ editingKey: '' });
    };

    // 保存
    save = (form, key) => {
        const { datalist } = this.state
        form.validateFields((error, row) => {
            if (error) {
                return;
            }
            const index = datalist.findIndex(item => key === item.key);
            if (index > -1) {
                const item = datalist[index];
                datalist.splice(index, 1, {
                    ...item,
                    ...row,
                });
                this.setState({ datalist });
                this.props.updateParent(datalist);
                this.setState({ editingKey: '' });
            } else {
                datalist.push(row);
                this.setState({ editingKey: '' });
            }
        });
    }

    isEditing = record => record.key === this.state.editingKey;

    edit(key) {
        this.setState({ editingKey: key });
    }

    handleCloseColumn = () => {
        this.props.onRef(false);
    }

    moveRow = (dragIndex, hoverIndex) => {
        const { datalist } = this.state;
        const dragRow = datalist[dragIndex];
        this.setState(
            update(this.state, {
                datalist: {
                    $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
                },
            }), () => {
                this.props.updateParent(this.state.datalist);
            }
        );
    };

    render() {
        const { columns, datalist } = this.state;
        const mergedColumns = columns.map((col) => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    inputType: (col.dataIndex === 'width') ? 'number' : (col.dataIndex === 'isShow' ? 'select' : 'text'),
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: this.isEditing(record),   // 判断编辑哪一行
                }),
            };
        });
        const components = {
            body: {
                cell: EditableCell,
                row: DragableBodyRow,
            },
        };

        return (
            <Modal
                width="600px"
                title="数据列设置"
                visible={this.props.visible}
                maskClosable={false}		                            // 点击蒙层不允许关闭
                footer={null}
                onCancel={this.handleCloseColumn}	                    // 右上角的关闭按钮
            >
                <div className="dangerWrap">
                    <EditableContext.Provider value={this.props.form}>
                        <DndProvider backend={HTML5Backend}>
                            <Table
                                components={components}                     // 覆盖默认的 table 元素
                                // bordered
                                dataSource={datalist}                   // 数据数组
                                columns={mergedColumns}
                                rowKey={record => record.key}               // 唯一的key值
                                pagination={false}
                                onRow={(record, index) => ({
                                    index,
                                    moveRow: this.moveRow,
                                })}
                            />
                        </DndProvider>
                    </EditableContext.Provider>
                </div>
            </Modal>
        )
    }
}

export default (Form.create({})(EditTable));